import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CsmFolder = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: 'async-folder' */ './csm-folder')),
});
